import React, {useState} from 'react'
import {useQuery} from '@apollo/client'
import {GetActiveLoyaltyQuery} from '@data/__generated__/types.main'
import useUserId from '@hooks/useUserId'
import useWebsiteId from '@hooks/useWebsiteId'
import useWidth from '@hooks/useWidth'

import LoyaltyAuth from './LoyaltyAuth'
import LoyaltyRewards from './LoyaltyRewards'
import {meQuery, preferencesQuery} from './query'
import SkeletonSuspense from './SkeletonSuspense'

import styles from './styles.module.css'

export interface LoyaltyProps {
  activeLoyalty: GetActiveLoyaltyQuery['activeLoyalty']
}

export default function LoyaltyProgram(props: LoyaltyProps) {
  const [registerSuccess, setRegisterSuccess] = useState<boolean>(false)
  const [loginSuccess, setLoginSuccess] = useState<boolean>(false)

  const userId = useUserId()
  const {activeLoyalty} = props
  const websiteId = useWebsiteId()

  const width = useWidth()
  const isMobile = width < 768

  const {data: me} = useQuery(meQuery)
  const user = me?.me

  const {data} = useQuery(preferencesQuery, {variables: {websiteId}})
  const loyaltyProgram = data?.preferences?.loyaltyProgram || 'None'

  if (!user) {
    return (
      <div className={styles.containerLoginSession}>
        Inicia sesión para revisar el programa de Fidelización
      </div>
    )
  }

  const preferences = {
    loyaltyType: activeLoyalty.name,
    activeLoyalty: activeLoyalty,
    user,
    websiteId,
    loyaltyProgram: loyaltyProgram
  }
  const loading = !userId || !loyaltyProgram || !me
  return (
    <div>
      {isMobile ? (
        <img
          className={styles.imageMobile}
          src={activeLoyalty?.imagesWebMobile?.banner?.url}
          alt={activeLoyalty?.imagesWebMobile?.altImgBanner}
        />
      ) : (
        <img
          src={activeLoyalty?.imagesWeb?.banner?.url}
          alt={activeLoyalty?.imagesWeb?.altImgBanner}
        />
      )}

      <div className={styles.container}>
        <SkeletonSuspense loading={loading} lines={1}>
          <>
            {registerSuccess && loginSuccess ? (
              <LoyaltyRewards
                websiteId={websiteId}
                loginSuccess={loginSuccess}
                activeLoyalty={activeLoyalty}
                user={user}
              />
            ) : (
              <LoyaltyAuth
                preferences={preferences}
                setPreferences={() => {}}
                activeLoyalty={activeLoyalty}
                refetchPreferences={() => {}}
                registerSuccess={registerSuccess}
                setRegisterSuccess={setRegisterSuccess}
                setLoginSuccess={setLoginSuccess}
              />
            )}
          </>
        </SkeletonSuspense>
      </div>
    </div>
  )
}
